<template>
	<div id="app">
		<div class="interfaceLoading" v-loading="loading" v-if="interfaceLoading" element-loading-text="拼命加载中"></div>
		<router-view ref="view" />
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { getMenusByUserId } from 'api/module/common'

export default {
	name: 'App',
	data() {
		return {
			loading: true
		}
	},
	computed: {
		...mapState('common', {
            interfaceLoading: state => state.interfaceLoading
        })
	},
	methods: {
		// 获取权限
		getMenusByUserId() {
			getMenusByUserId({
				userId: JSON.parse(this.$localStorage.get('userData')).id
			}).then(res => {
				// console.log(res)
				this.$localStorage.set('role', JSON.stringify(res.data.param))
                let cistyState = res.data.isProvincialStation ? false : true
                this.updateCityState(cistyState)
                if(!this.$localStorage.get('fillRole')){
                    this.$localStorage.set('fillRole', JSON.stringify(res.data.fillRole))
                }
                if(!this.$localStorage.get('xhRole')){
                    this.$localStorage.set('xhRole', JSON.stringify(rex.data.xieHuiRole))
                }
			})
		},

		...mapActions('common', [ 'getMaterialTree' ]),
		...mapMutations('common', ['updateCityState']),
	},
	mounted() {
		document.body.οnresize = this.resize

		// 关闭引导
		var appLoadingBox = document.getElementById('app-loading-box')
		var appLoading = document.getElementById('app-loading')
		if (appLoading && appLoadingBox) {
			appLoadingBox.removeChild(appLoading)
			appLoadingBox.style.opacity = 0
			setTimeout(function() {
				if (appLoadingBox) {
					document.body.removeChild(appLoadingBox)
				}
			}, 1000)
		}
	},
	created() {
		this.getMaterialTree()

		if (this.$localStorage.get('userData')) {
			this.getMenusByUserId()
		}
	},
	watch: {}
}
</script>

<style lang="less">
@import 'assets/baseStyle/publicComponents.less';
@import 'assets/baseStyle/lib.less';
html, body {
	margin: 0;
	height: 100%;
	background: #f0f0f0;
	font-family: Microsoft YaHei;
	overflow: hidden;
}

* {
	font-family: Microsoft YaHei;
}

#app {
	height: 100%;
	overflow: hidden;
}
</style>




// WEBPACK FOOTER //
// src/App.vue